
import { UserType } from "../../../services/medicationmanagement/medsUser/MedsUserApi";
import {
  CriticalBadge,
  CautionBadge,
  NewAdmissionBadge,
  SuccessBadge,
} from "../../common/status-badge/StatusBadge";
import { StatusDetails } from "../../../services/medicationmanagement/patientApi/models/StatusDetails";
import { useEffect } from "react";

export interface IStatusProps {
  statuses: StatusDetails
  userType: UserType; 
  chartReviewConfiremd?: boolean;
}

export const StatusDisplay = (props: IStatusProps) => {

  if (props.userType === UserType.Doctor
    || props.userType == UserType.Dentist 
    || props.userType == UserType.GeneralStaffAdmin 
    || props.userType == UserType.NursePractitioner 
    || props.userType == UserType.Optometrist 
    || props.userType == UserType.RegisteredNurse ) {
    return (
      <>
        {props.statuses?.isNewAdmission && (
          <NewAdmissionBadge>New admission</NewAdmissionBadge>
        )}
     </>
    );
  } else if (props.userType === UserType.Pharmacist) {
    return (
      <>
        {props.statuses?.isNewAdmission && (
          <NewAdmissionBadge>New admission</NewAdmissionBadge>
        )}
        {(props.statuses?.hasChartChanged || (props.statuses?.hasOnlyChartReviewChanges && !props.chartReviewConfiremd )) && <CautionBadge>Chart changes</CautionBadge>}
      </>
    );
  }

  return <></>;
};
